import { FeatureFlag } from '../FeatureFlag';

export const hideAccountCreation = new FeatureFlag({
    key: 'hide-account-creation',
    createdOn: '2025-10-27',
    defaultValue: false,
});
